import { ErrorBlock, Flex } from "src/components";
import styling from "./ErrorPage.module.scss";

export const ErrorPage = () => {
	return (
		<Flex.Row width="100vw" height="100vh" alignment="center" className={styling["wrapper"]}>
			<ErrorBlock />
		</Flex.Row>
	);
};
